import { MDBInputGroup } from "mdb-react-ui-kit";
import CommonChipItem from "./CommonChipItem";

export default function BusinessSkillChipItem(
    {
        chip,
        handleRemove,
        handleChange,
        textBeforeMin,
        textBeforeMax,
    }
) {
    return (
        <div className="row">
            <div className="col-4">
                <CommonChipItem chip={ chip } handleRemove={ handleRemove }/>
            </div>
            <div className="col-3">
                <MDBInputGroup className='mb-3' noBorder textBefore={ textBeforeMin }>
                    <input type="number" value={ chip.minYears }
                           onChange={ ( e ) => handleChange( chip, 'minYears', +e.target.value ) }/>
                </MDBInputGroup>
            </div>
            <div className="col-3">
                <MDBInputGroup className='mb-3' noBorder textBefore={ textBeforeMax }>
                    <input type="number" value={ chip.maxYears }
                           onChange={ ( e ) => handleChange( chip, 'maxYears', +e.target.value ) }/>
                </MDBInputGroup>
            </div>
        </div>
    );
}